import {defaultConfiguration, defaultConfigurationGoogle, IConfigurationState, initialConfigurationState} from "../../state/configuration/configuration.state";
import {ConfigurationActions, EConfigurationActions} from "../../actions/configuration/configuration.actions";

export const configurationReducers = (
  state = initialConfigurationState,
  action: ConfigurationActions
): IConfigurationState=>{
  switch (action.type) {
    case EConfigurationActions.LoadConfigurationForHost:
      return state
    case EConfigurationActions.LoadConfigurationSuccess:
      return {
        data: action.payload.configuration,
        isLoaded: true
      };
    case EConfigurationActions.LoadConfigurationFailure:
      return {
        data: {
          ...defaultConfiguration
        },
        isLoaded: false
      };
    case EConfigurationActions.SetConfigurationHost:
      return {
        ...state,
        data: {
          ...state.data,
          api: {
            ...state.data.api,
            host: action.payload.host
          }
        }
      };
    default:
      return state;
  }

};

